import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout/Layout.component';
import Breadcrumbs from '../../components/Breadcrumbs.component';
import { useStyles } from '../styles';
import Pagination from '../../components/Pagination.component';
import { Typography } from '@material-ui/core';
import SaveAltIcon from '@material-ui/icons/SaveAlt';
import {
  Examinee,
  ExamineeStatus,
  ExamineeListTableItem,
  ExamineeStatusPl,
  ExamineeListSortBy,
} from './ExamineeList.types';
import { deleteExaminee, deleteExamineeList, exportExamineeApi } from '../../services/images/images.service';
import { useLayoutContext } from '../../Context/Layout.context';
import { SelectableTable } from '../../components/SelectableTable/SelectableTable.component';
import { getExamCommitteeNameFromId } from '../SampleAssessmentRepo/Helpers/AccountTypeRendering';
import DropdownMenuFilter from '../../components/DropdownMenu/DropdownMenuFilter.component';
import ActionsMenu from '../../components/ActionsMenu/ActionsMenu.component';
import { committeesArray } from '../../models/committees.types';
import { DateFilter } from '../../components/SelectableTable/filters/DateFilter.component';
import { getCandidateCardStatus } from './ExamineeListTable/GetExamineeCardStatus/GetExamineeCardStatus.component';
import FilterListIcon from '@material-ui/icons/FilterList';
import { formatDate } from '../Assessment/Helpers/FormatDate.component';
import { SelectedRecordCountDisplay } from '../../components/SelectableTable/SelectedRecordCountDisplay/SelectedRecordCountDisplay.component';
import { UserPermission } from '../../enum/userPermissions';
import usePermission from '../../hooks/usePermission';
import { useTranslation } from 'react-i18next';
import { Paths } from '../../utils/routerUrls';
import OutlinedButton from '../../components/buttons/OutlinedButton.component';
import { exportFile } from '../../utils/servicesHelper';
import { ActionMenuItem } from '../../components/ActionsMenu/ActionsMenu.types';
import { Prompt } from '../../components/Prompt/Prompt.component';
import Pipe from '../../assets/icons/pipe.svg';
import { ExamineeDetails } from '../../components/ExamineeDetails/ExamineeDetails.component';
import { ExamRepositoryModalType } from '../../components/ExamResultsRepository/ExamResultsRepository.types';
import { ExamResultsRepository } from '../../components/ExamResultsRepository/ExamResultsRepository.component';
import { SourceSystemType } from '../../models/examSessionDto.types';
import TooltipOne from '../../components/TooltipOne/TooltipOne.component';
import { useExamineeTableColumns } from './useExamineeTableColumns';
import { useExamineeTableData } from './useExamineeTableData';

export const Examinees: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    adjustmentsFilter,
    adjustmentTypesFilter,
    adjustmentPermissionsFilter,
    statusFilter,
    filterState,
    pageInfo,
    sortByProperty,
    setSortByProperty,
    isDescending,
    setIsDescending,
    setHandleRefresh,
    filter,
    itemsSelection,
    setItemsSelection,
    adjustmentTypes,
    adjustmentPermissions,
    handleFilterChange,
    getPages,
    filtersApplied,
    handleStatusFilterChange,
    handleAdjustmentsFilterChange,
    examCommitteeFilter,
    handleExamCommitteeFilterChange,
    examinees,
    uncheckAllFilters,
    uncheckFilterItem,
  } = useExamineeTableData();

  const { showLoader, openAlert, isSidebarMinimized } = useLayoutContext();
  const [rows, setRows] = useState<ExamineeListTableItem[]>([]);
  const [IsDeletePromptOpen, setIsDeletePromptOpen] = useState<boolean>(false);
  const [IsDeleteSelectedPromptOpen, setIsDeleteSelectedPromptOpen] = useState<boolean>(false);
  const [IsSuccess, setIsSuccess] = useState<boolean>(false);
  const [examineeId, setExamineeId] = useState<string>();
  const [deletedCards, setDeletedCards] = useState<string>();
  const [openDetails, setOpenDetails] = useState<boolean>(false);
  const [selectedSoureSystem, setSelectedSourceSystem] = useState<SourceSystemType>();
  const [selectedSheetCode, setSelectedSheetCode] = useState('');
  const [selectedSheetId, setSelectedSheetId] = useState<string>('');
  const [selectedExamineeId, setSelectedExamineeId] = useState<string>('');
  const [isExamResultsRepositoryOpen, setIsExamResultsRepositoryOpen] = useState<boolean>(false);
  const [examRepositoryModalType, setExamRepositoryModalType] = useState<ExamRepositoryModalType>(
    ExamRepositoryModalType.results,
  );

  const [anchorElExamCommittee, setAnchorElExamCommittee] = useState<SVGSVGElement | HTMLElement | null>(null);
  const [anchorElStatus, setAnchorElStatus] = useState<SVGSVGElement | HTMLElement | null>(null);
  const [anchorElAdjustments, setAnchorElAdjustments] = useState<SVGSVGElement | HTMLElement | null>(null);
  const [forceDeselectAllItems, setForceDeselectAllItems] = useState<boolean>(false);

  const hasAdminOkeResultsAccessPermission = usePermission(UserPermission.AdminOkeResultsAccess);

  const { columns } = useExamineeTableColumns();

  const getActionsMenuIcon = (data: Examinee, rowIndex: number): JSX.Element => {
    const items: ActionMenuItem[] = [];
    items.push({
      text: 'Dane szczegółowe',
      onClick: () => {
        setExamineeId(data.examineeId);
        setOpenDetails(true);
      },
    });

    if (data.status === (ExamineeStatus.Empty || ExamineeStatus.Incomplete)) {
      items.push({
        text: 'Usuń egzamin zdającego',
        onClick: () => {
          setExamineeId(data.examineeId);
          setIsDeletePromptOpen(true);
        },
      });
    }

    if (hasAdminOkeResultsAccessPermission && data.assessmentSessionsClosed)
      items.push({
        text: 'Dokumentacja',
        onClick: () => {
          setExamRepositoryModalType(ExamRepositoryModalType.examineeDocumentation);
          setSelectedSourceSystem(data.sourceSystemTypeId);
          setSelectedSheetCode(data.sheetCode);
          setSelectedSheetId(data.examSheetId);
          setSelectedExamineeId(data.examineePesel ? data.examineePesel : data.examineeId);
          setIsExamResultsRepositoryOpen(true);
        },
      });

    return <ActionsMenu menuItems={items} rowIndex={rowIndex} />;
  };

  const getActionsMenuIconForSelectedRecord = (): JSX.Element => {
    const items: ActionMenuItem[] = [];
    items.push({
      text: 'Usuń egzamin zdającego',
      onClick: () => setIsDeleteSelectedPromptOpen(true),
    });
    return <ActionsMenu menuItems={items} transformOrigin={{ horizontal: 'left', vertical: 'top' }} />;
  };

  const handleClickExamCommitteeMenu = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElExamCommittee) {
      setAnchorElExamCommittee(event.currentTarget);
    } else setAnchorElExamCommittee(null);
  };

  const handleClickStatus = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElStatus) {
      setAnchorElStatus(event.currentTarget);
    } else setAnchorElStatus(null);
  };

  const handleClickAdjustment = (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
    if (!anchorElAdjustments) {
      setAnchorElAdjustments(event.currentTarget);
    } else setAnchorElAdjustments(null);
  };

  const getAdjustmentsMenuItems = () => {
    const menuItems: [string, string][] = [
      ['TAK', 'TAK'],
      ['NIE', 'NIE'],
    ];

    if (adjustmentTypes.length) {
      menuItems.push(['hr', 'Sposoby dostosowań']);
      adjustmentTypes.forEach((e) => {
        menuItems.push([e.name, e.id]);
      });
    }
    if (adjustmentPermissions.length) {
      menuItems.push(['hr', 'Uprawnienia do dostosowań']);
      adjustmentPermissions.forEach((e) => {
        menuItems.push([e.name, e.id]);
      });
    }
    return menuItems;
  };

  const filterElements: { [key: string]: JSX.Element } = {
    examCommittee: usePermission(UserPermission.AdminExamineeRead) ? (
      <div>
        <TooltipOne title="Ustaw filtr do wyszukiwania: Komisja" placement="top">
          <FilterListIcon
            className={examCommitteeFilter.length ? classes.activeFilter : ''}
            onClick={handleClickExamCommitteeMenu}
            aria-controls="ExamCommittee-menu"
            aria-haspopup="true"
          />
        </TooltipOne>
        <DropdownMenuFilter
          anchorEl={anchorElExamCommittee}
          setAnchorEl={setAnchorElExamCommittee}
          menuItems={committeesArray.map((e) => e.name)}
          hasCheckbox={true}
          checkedItems={examCommitteeFilter}
          onChange={handleExamCommitteeFilterChange}
          uncheckAllMenuItems={handleExamCommitteeFilterChange}
        />
      </div>
    ) : (
      <FilterListIcon style={{ color: 'gray', pointerEvents: 'none' }} />
    ),
    importDate: (
      <DateFilter
        fromValueName="importDateFrom"
        toValueName="importDateTo"
        onChange={handleFilterChange}
        resetFilter={filter.importDateFrom === '' && filter.importDateTo === ''}
        isActiveFilter={filter.importDateFrom !== '' || filter.importDateTo !== ''}
        valueFrom={filter.importDateFrom as string}
        valueTo={filter.importDateTo as string}
      />
    ),
    status: (
      <div>
        <TooltipOne title="Ustaw filtr do wyszukiwania: Status" placement="top">
          <FilterListIcon
            className={statusFilter.length ? classes.activeFilter : ''}
            onClick={handleClickStatus}
            aria-controls="Status-menu"
            aria-haspopup="true"
          />
        </TooltipOne>
        <DropdownMenuFilter
          anchorEl={anchorElStatus}
          setAnchorEl={setAnchorElStatus}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
          transformOrigin={{ vertical: 'top', horizontal: 'center' }}
          menuItemsWithImages={[
            { text: ExamineeStatusPl.Completed, jsxElement: getCandidateCardStatus(ExamineeStatus.Completed) },
            { text: ExamineeStatusPl.Incomplete, jsxElement: getCandidateCardStatus(ExamineeStatus.Incomplete) },
            { text: ExamineeStatusPl.Empty, jsxElement: getCandidateCardStatus(ExamineeStatus.Empty) },
          ]}
          hasCheckbox={true}
          checkedItems={statusFilter}
          onChange={handleStatusFilterChange}
          uncheckAllMenuItems={handleStatusFilterChange}
        />
      </div>
    ),
    adjustments: (
      <div>
        <TooltipOne title="Ustaw filtr do wyszukiwania: Dostosowania" placement="top">
          <FilterListIcon
            className={
              adjustmentsFilter.length || adjustmentTypesFilter.length || adjustmentPermissionsFilter.length
                ? classes.activeFilter
                : ''
            }
            onClick={handleClickAdjustment}
            aria-controls="Status-menu"
            aria-haspopup="true"
          />
        </TooltipOne>
        <DropdownMenuFilter
          anchorEl={anchorElAdjustments}
          setAnchorEl={setAnchorElAdjustments}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          menuItemsWithValue={getAdjustmentsMenuItems()}
          hasCheckbox={true}
          checkedItems={adjustmentsFilter.concat(adjustmentTypesFilter).concat(adjustmentPermissionsFilter)}
          onChange={handleAdjustmentsFilterChange}
          uncheckAllMenuItems={handleAdjustmentsFilterChange}
        />
      </div>
    ),
  };

  useEffect(() => {
    if (examinees.length) {
      const transformedData: ExamineeListTableItem[] = examinees.map((e, index) => {
        return {
          id: e.examineeId,
          tableEnterId: e.examineeId,
          examCommittee: getExamCommitteeNameFromId(+e.examCommittee),
          schoolCode: e.schoolCode,
          examineeCode: e.examineeCode,
          examineePesel: e.examineePesel,
          examName: e.examName,
          sheetCode: e.sheetCode,
          room: e.room,
          importDate: formatDate(new Date(e.importDate)),
          status: getCandidateCardStatus(e.status, true),
          adjustments: e.adjustments ? 'TAK' : 'NIE',
          actions: getActionsMenuIcon(e, index),
        };
      });

      setRows(transformedData);
    } else {
      setRows([]);
    }
  }, [examinees]);

  const exportExaminee = () => {
    const abortController = new AbortController();
    const { signal } = abortController;
    const filters = Object.keys(filter).map((key) => {
      if (Array.isArray(filter[key])) {
        return (filter[key] as string[]).join(',');
      }
      return filter[key];
    });
    showLoader(true, 'Eksportuję dane');
    exportExamineeApi(signal ?? undefined, sortByProperty, isDescending, ...(filters as string[]))
      .then(
        (response: Blob) => {
          exportFile(response, 'wykaz_zdajacych');
        },
        () => {
          openAlert('error', 'Export danych nie powiódł się');
        },
      )
      .finally(() => showLoader(false));
  };

  const handleDelete = () => {
    setIsDeletePromptOpen(false);
    showLoader(true);
    deleteExaminee(examineeId)
      .then(
        () => {
          openAlert('delete_success');
          setHandleRefresh(true);
          setForceDeselectAllItems(true);
        },
        () => {
          openAlert('delete_error');
        },
      )
      .finally(() => {
        setHandleRefresh(false);
        showLoader(false);
      });
  };

  const handleDeleteSelected = () => {
    setIsDeleteSelectedPromptOpen(false);
    showLoader(true);
    deleteExaminee(itemsSelection.items)
      .then(
        (response) => {
          setDeletedCards(response);
          setIsSuccess(true);
          setForceDeselectAllItems(true);
        },
        () => {
          openAlert('delete_error');
        },
      )
      .finally(() => {
        setHandleRefresh(false);
        showLoader(false);
      });
  };

  const handleDeleteAll = () => {
    setIsDeleteSelectedPromptOpen(false);
    const filters = Object.keys(filter).map((key) => {
      if (Array.isArray(filter[key])) {
        return (filter[key] as string[]).join(',');
      }
      return filter[key];
    });
    deleteExamineeList(sortByProperty, isDescending, ...(filters as string[]))
      .then(
        (response) => {
          setDeletedCards(response.data);
          setIsSuccess(true);
          setForceDeselectAllItems(true);
        },
        () => {
          openAlert('delete_error');
        },
      )
      .finally(() => {
        setHandleRefresh(false);
      });
  };

  const onExamineeActionsClick = (id: string) => {
    setExamineeId(id);
    setOpenDetails(true);
  };

  return (
    <React.Fragment>
      <Layout viewType="admin">
        <div className={classes.tableAndBreadcrumContainer}>
          <div className={classes.adminBreadcrumbHeader}>
            <div className={classes.usersHeaderContainer}>
              <Breadcrumbs listRoute={Paths.examinees} currentList={t('global:sidebar.examinees')} />
              <div className={classes.adminButtonsContainer}>
                <span style={{ marginRight: 5 }}>
                  <OutlinedButton
                    className={classes.exportButton}
                    startIcon={<SaveAltIcon className={classes.exportButtonIcon} />}
                    onClick={exportExaminee}
                  >
                    Eksportuj
                  </OutlinedButton>
                </span>
              </div>
            </div>
          </div>
          <div className={classes.tableWhiteCardFlex}>
            <div className={classes.filtersContainerFlex}>
              <div className={classes.usersHeaderContainer}>
                <Typography variant={'h1'} className={classes.gridHeader}>
                  {t('examinees:header.title')}
                </Typography>
                <div style={{ display: 'flex' }}>
                  <SelectedRecordCountDisplay selection={itemsSelection} totalItems={pageInfo?.totalCount} />
                  {itemsSelection.items.length > 0 && (
                    <>
                      <img src={Pipe} alt="ikona pionowa linia" /> {getActionsMenuIconForSelectedRecord()}
                    </>
                  )}
                </div>
              </div>
              <Pagination className={classes.adminPaginationFlex} pageInfo={pageInfo} getPage={getPages} />
            </div>
            <div
              className={[
                classes.adminTableContainerFlex,
                isSidebarMinimized ? classes.adminTableContainerFullWidth : classes.adminTableContainerNarrowed,
              ].join(' ')}
            >
              <SelectableTable<ExamineeListTableItem, ExamineeListSortBy>
                columns={columns}
                rows={rows}
                onFilterChange={handleFilterChange}
                filter={filter}
                filterElements={filterElements}
                isMultiChoice={true}
                closeFilterItem={uncheckFilterItem}
                uncheckAllFilters={uncheckAllFilters}
                filterbar={filterState}
                isDescending={isDescending}
                sortByProperty={sortByProperty}
                setSortByColumn={setSortByProperty}
                setIsDescending={setIsDescending}
                withoutEmptyMessage={true}
                filterSearch={filtersApplied && !examinees.length}
                withHighFilterRow={true}
                onSelectionChanged={setItemsSelection}
                caption={t('global:sidebar.examinees')}
                onEnterMethod={onExamineeActionsClick}
                setForceDeselectAllItems={setForceDeselectAllItems}
                forceDeselectAllItems={forceDeselectAllItems}
              />
            </div>
          </div>
          {openDetails && <ExamineeDetails onClose={() => setOpenDetails(false)} examineeId={examineeId} />}
          {isExamResultsRepositoryOpen && (
            <ExamResultsRepository
              sourceSystem={selectedSoureSystem}
              sheetCode={selectedSheetCode}
              examSheetId={selectedSheetId}
              onClose={() => setIsExamResultsRepositoryOpen(false)}
              type={examRepositoryModalType}
              examineeId={selectedExamineeId}
            />
          )}
          <Prompt
            type="confirmation"
            mainActionButtonText="TAK"
            open={IsDeletePromptOpen}
            mainText={`Czy na pewno chcesz usunąć egzamin zdającego?`}
            onConfirm={() => handleDelete()}
            onCancel={() => setIsDeletePromptOpen(false)}
          />
          <Prompt
            type="confirmation"
            mainActionButtonText="Potwierdź"
            open={IsDeleteSelectedPromptOpen}
            mainText={`Egzamin zostanie usunięty dla zdających ze statusem kart:`}
            subTexts={[{ text: 'Brak karty, Karta niekompletna' }]}
            onConfirm={() => (itemsSelection.isAll ? handleDeleteAll() : handleDeleteSelected())}
            onCancel={() => setIsDeleteSelectedPromptOpen(false)}
          />
          <Prompt
            type="success"
            mainActionButtonText="Powrót"
            open={IsSuccess}
            mainText={`Egzamin zostanie usunięty dla następującej liczby zdających: ${deletedCards}`}
            onConfirm={() => {
              setIsSuccess(false), setHandleRefresh(true);
            }}
          />
        </div>
      </Layout>
    </React.Fragment>
  );
};
